import { gql } from 'react-apollo';

export default gql`
  query currentInvestment($investmentId: ID) {
    currentInvestment(investmentId: $investmentId) {
      _id
      offerId
      paymentType
      paymentMethod
      investmentStatus
      subscriptionAgreementStatus
      brokerageAgreementStatus
      agreementEnvelopeId
      brokerageAgreementEnvelopeId
      paymentSent
      networth
      income
      investmentAmount
      investmentAmountCrypto
      walletAddress
      transactionId
      receiptImageId
      question_one
      question_two
      question_three
      question_four
      question_five
      question_six
      question_seven
      question_eight
      question_nine
      question_ten
      investmentReviewAgreement
      closingDateAgreement
      crowdfundingQuestion
      crowdfundingAmount
      toggleSecondSigner
      secondSignerEmail
      countryOfResidence
      confirmCountryOfResidence
      typeOfInvestment
      investmentTypeDocument
      entityType
      secondSignerName
      paymentDetails {
        _id
        subscriptionAgreementDocumentId
        brokerageAgreementDocumentId
        pricePerShareOrToken
        acceptedPaymentMethod
        acceptedBankTypes
        acceptedCryptoTypes
        ethWalletAddress
        btcWalletAddress
        xlmWalletAddress
        xrpWalletAddress
        usdcWalletAddress
        tusdWalletAddress
        paxWalletAddress
        bankName
        bankAddress
        beneficiaryName
        swiftCode
        accountNumber
        routingNumber
        memoLine
        IRAUrl
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/currentInvestment.js